import { Link } from 'react-router-dom';

const services = [
  {
    path: '/plat-personnalise',
    title: 'Plat Personnalisé',
    subtitle: 'Créez votre repas',
    description: "Sélectionnez vos aliments préférés et composez votre panier repas avec calcul automatique des glucides, calories et Nutri-Score en temps réel.",
    image: 'https://readdy.ai/api/search-image?query=custom%20meal%20preparation%20fresh%20ingredients%20vegetables%20proteins%20grains%20on%20kitchen%20counter%20bright%20natural%20light%20food%20photography&width=600&height=400&seq=svc2&orientation=landscape',
    icon: 'ri-magic-line',
    color: 'from-teal-500 to-emerald-500',
    tag: 'Personnalisé',
  },
  {
    path: '/info-aliment',
    title: 'Info Aliment',
    subtitle: 'Bibliothèque nutritionnelle',
    description: "Recherchez n'importe quel aliment et obtenez instantanément ses valeurs nutritionnelles complètes : glucides, protéines, lipides, index glycémique et Nutri-Score.",
    image: 'https://readdy.ai/api/search-image?query=food%20nutrition%20database%20library%20various%20healthy%20foods%20vegetables%20fruits%20grains%20proteins%20arranged%20beautifully%20white%20background%20overhead%20view&width=600&height=400&seq=svc3&orientation=landscape',
    icon: 'ri-search-line',
    color: 'from-amber-500 to-orange-500',
    tag: '200+ aliments',
  },
  {
    path: '/contact',
    title: 'Contact',
    subtitle: 'Nous contacter',
    description: "Une question, une suggestion ou besoin d'aide ? Écrivez-nous à contact@dt1symply.lbtdesign.fr, notre équipe est là pour vous.",
    image: 'https://readdy.ai/api/search-image?query=friendly%20healthcare%20support%20team%20communication%20modern%20office%20bright%20clean%20professional%20medical%20wellness%20environment&width=600&height=400&seq=svc4&orientation=landscape',
    icon: 'ri-customer-service-2-line',
    color: 'from-rose-500 to-pink-500',
    tag: 'Support',
  },
];

export default function ServicesSection() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block bg-teal-50 text-teal-600 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Nos services
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Tout ce dont vous avez besoin
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto">
            Trois outils complémentaires pour gérer votre alimentation au quotidien.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc) => (
            <Link
              key={svc.path}
              to={svc.path}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-teal-200 transition-all duration-300 cursor-pointer block"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={svc.image}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className={`absolute top-3 left-3 w-9 h-9 flex items-center justify-center rounded-lg bg-gradient-to-br ${svc.color}`}>
                  <i className={`${svc.icon} text-white text-base`}></i>
                </div>
                <span className="absolute top-3 right-3 bg-white/90 text-gray-700 text-xs font-semibold px-2 py-1 rounded-full">
                  {svc.tag}
                </span>
              </div>
              <div className="p-5">
                <div className="text-xs text-teal-600 font-semibold mb-1">{svc.subtitle}</div>
                <h3 className="font-bold text-gray-900 text-base mb-2">{svc.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-4">{svc.description}</p>
                <div className="flex items-center gap-1 text-teal-600 text-sm font-semibold group-hover:gap-2 transition-all">
                  Découvrir
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}